import { useCallback } from 'react'

type ClearErrorFn = (value: null) => void

export function useErrorClearingSelectUpdater<T>(
  updateSelected: (nodes: T[] | undefined) => void,
  clearError?: ClearErrorFn,
) {
  return useCallback(
    (nodes?: T[]) => {
      updateSelected(nodes)
      if (nodes?.length && clearError) {
        clearError(null)
      }
    },
    [updateSelected, clearError],
  )
}
